import { ModalV2 } from '@components'
import { useBusinessContext } from '@context'
import { IInvoice } from '@query'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InvoiceForm } from '../InvoiceForm'
import { CreateInvoiceBlockedStep } from './CreateInvoiceBlockedStep'
import { CreateInvoiceSettingsStep } from './CreateInvoiceSettingsStep'

interface Props {
  onClose: () => void
  onSubmit: (created?: IInvoice) => void
}

export const CreateInvoiceModal: React.FC<Props> = ({ onClose, onSubmit }) => {
  const [t] = useTranslation()
  const { data: business } = useBusinessContext()
  const [editingBasics, setEditingBasics] = useState(false)

  if (!business) return null

  const showInvoiceForm = business.can_invoice
  const showSettings = !showInvoiceForm && editingBasics

  return (
    <ModalV2
      isVisible
      header={
        showInvoiceForm
          ? t('invoicing.form.titleCreate')
          : showSettings
          ? t('settings.sections.invoicingBasics')
          : undefined
      }
      handleOnClose={onClose}
      width={showInvoiceForm ? 800 : 560}
      height={900}
      autoHeight={!showInvoiceForm}
    >
      {showInvoiceForm ? (
        <InvoiceForm
          onSubmit={onSubmit}
          defaultValues={{
            payment_condition_days: business.invoicing_default_payment_condition_days,
            penalty_interest: business.invoicing_default_penalty_interest
          }}
        />
      ) : showSettings ? (
        <CreateInvoiceSettingsStep onBack={() => setEditingBasics(false)} onClose={onClose} />
      ) : (
        <CreateInvoiceBlockedStep onAddDetails={() => setEditingBasics(true)} onClose={onClose} />
      )}
    </ModalV2>
  )
}
